import React from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar'
import I18n from '../../resources/i18n/I18n'
import WrapperLoader from '../loader/WrapperLoader'

const ProgressTile = ({ data, total, unit, totalUnit, loading }) => {
  const getPourcentage = () => {
    let pourcent = 0
    if (total) {
      pourcent = (data / total) * 100
    }
    return pourcent.toFixed(2)
  }

  return (
    <WrapperLoader loading={loading}>
      <div className="dashboard-tile progress-tile">
        <div className="legend">
          <div className="bold">{`${data} ${unit}`}</div>
          <div>{`${I18n.t('For')} ${total} ${totalUnit}`}</div>
        </div>
        <div>
          <div className="key-number">{getPourcentage()}%</div>
          <ProgressBar now={getPourcentage()} />
        </div>
        <div className="progress-start">0%</div>
        <div className="progress-end">100%</div>
      </div>
    </WrapperLoader>
  )
}

export default ProgressTile
